import { IConfig } from '@vivli/shared/infrastructure/interface';
import { useQueryParamsHook, useStorage } from '@vivli/shared/infrastructure/hook';
import { IPortalConfig } from '@vivli/core/infrastructure/interface';

const portalConfigSessionKey = 'VivliPortalConfig';
const portalNameSessionKey = 'VivliPortalName';

//reusable function for configuring custom portals
export function usePortalConfig(): IPortalConfig {
    const { search } = useQueryParamsHook();
    const isPortal = location.pathname.startsWith('/portal');
    const { getItem, setItem } = useStorage();

    const portalName = (): string | null => {
        if (isPortal) {
            return location.pathname.split('/portal/')[1]?.toLowerCase();
        } else {
            return 'default';
        }
    };

    const getCurrentPortalName = (): string => {
        const storedPortalName = getItem<string>(portalNameSessionKey);

        return storedPortalName || 'default';
    };

    const getPortalConfig = (config: IConfig): IConfig => {
        const portalConfig = { ...config };
        const storedPortalName = getItem<string>(portalNameSessionKey);

        // update the portal config only if the user is is on the search page
        if (portalName() && portalConfig?.customPortals.length > 0) {
            const customPortal = portalConfig.customPortals.find((portal) => portal.portalName == portalName());
            if (customPortal) {
                portalConfig.bannerConfig = customPortal.bannerConfig;
                portalConfig.initialSearch = customPortal.initialSearch || search;
                portalConfig.portalTitle = customPortal.portalTitle;

                setItem(portalNameSessionKey, portalName());
                setItem(portalConfigSessionKey, portalConfig);
            }
        } else if (storedPortalName) {
            // if we are not on the search page and we do have a stored portal, return the config for it
            const storedConfig = getItem<IConfig>(portalConfigSessionKey);

            // return the stored config if found, otherwise return the default config
            return storedConfig || portalConfig;
        }

        return portalConfig;
    };

    const getSearchLink = (): string => {
        const currentPortalName = getCurrentPortalName();
        return currentPortalName === 'default' ? '/' : `/portal/${currentPortalName}`;
    };

    return {
        getPortalConfig,
        getSearchLink,
        getCurrentPortalName
    };
}
